/**
 * Component to show a list of plans the account has signed up for or changed.  
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Grid,
         TableContainer, Table,  TableBody, TableCell, TableHead, TableRow, TablePagination, Typography} from '@mui/material';
import { format } from 'date-fns';

import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';

const abEnvironment = new AbEnvironment();

const PlanHistoryQuery = graphql`
query PlanHistoryQuery($accountId: UUID!, $first: Int, $offset: Int) {
  allAbSubscriptionTs(condition: {accountId: $accountId}, first: $first, offset: $offset orderBy: CREATED_DESC) {
    totalCount
    nodes {
      feePlanId
      feeMonthly
      feeAnnual
      abBillingDayOfMonth
      feePlanTByFeePlanId {
        feePlanName
      }
      created
    }
  }
}
`;

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
      marginTop: 24,
    },
    flex: {
      flex: 1,
    },
    paper: {
      width: '100%',
      marginTop: theme.spacing(1),
      overflow: 'auto',
    },
    tblHead: {
      backgroundColor: '#f1f1f1',
    },
    tblHeadRow: {
      height: 32,
    },
    tblHeadCell: {
      textAlign: 'left',
      verticalAlign: 'bottom',
      borderBottom: 0,
    }

});

class PlanHistory extends Component {

  constructor(props) {
    super(props);

    this.state = {
      page:              0,
      rowsPerPage:       5,
      outstandingSO:     0,
      requestCancelDialog: false,
      requestCancelSpinner: false
    };  
  }


  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
      page: 0,
    });
  };

  handleChangePage = (event, page) => {
    this.setState({page: page});
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value, page : 0});
  }

  render() {
    const { isAuthenticated, isAuthenticatedReseller, isAuthenticatedCustomer, isAuthenticatedAppBind, isUnauthenticatedCustomer, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    if (!isAuthenticated() || needAssent()) { 
      return ( <Redirect to='/home' /> );
    }    
    if (!isAuthenticatedCustomer() && !isUnauthenticatedCustomer() && !isAuthenticatedReseller() && !isAuthenticatedAppBind()) {
      // others cannot see this component
      return ( <Redirect to='/home' /> );
    } 
 
    // Determine the offset
    let offset = 0;
    if (this.state.page > 0) {
      offset = this.state.page * this.state.rowsPerPage
    }
    let first = this.state.rowsPerPage;

    return (
      <div className={classes.root}>
        <Grid container spacing={0} direction="row" justifyContent={"space-between"}>
          <Grid item>
            <Typography variant="h6">
              AppBind plan subscription history
            </Typography>
          </Grid>

        </Grid>


        <QueryRenderer
          environment={abEnvironment.getEnvironment()}
          query={PlanHistoryQuery}
          variables={{
            accountId: this.props.accountId,
            forceFetch: this.props.forceFetch,
            first: first,
            offset: offset
          }}
          render={({ error, props }) => {
            if (error) {
              logError(error.message);
              return (
                <ServerError/>
              );
            } else if (props) {


              let totalCount = props.allAbSubscriptionTs.totalCount;

              let theOrders = props.allAbSubscriptionTs.nodes;
              

              return (
                <div className={classes.paper}>
                  <TableContainer>
                    <Table>
                      <TableHead className={classes.tblHead}>
                        <TableRow className={classes.tblHeadRow}>
                          <TableCell className={classes.tblHeadCell}>Subscribed date</TableCell>
                          <TableCell className={classes.tblHeadCell}>Plan name</TableCell>
                          <TableCell className={classes.tblHeadCell}>Billing day</TableCell>
                          <TableCell className={classes.tblHeadCell}>Monthly fee</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>

                      {theOrders.map(n => {

                          let acceptedTime = format(new Date(n.created), 'yyyy-MM-dd');
                          let monthlyFeeFormatted = Number(n.feeMonthly).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                          return (
                            <TableRow key={n.created}>
                              <TableCell><Typography variant="body2">{acceptedTime}</Typography></TableCell>
                              <TableCell><Typography variant="body2">{n.feePlanTByFeePlanId.feePlanName}</Typography></TableCell>
                              <TableCell><Typography variant="body2">{n.abBillingDayOfMonth}</Typography></TableCell>
                              <TableCell><Typography variant="body2">{monthlyFeeFormatted}</Typography></TableCell>              
                            </TableRow>
                          )

                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <div style={{ marginTop: '10px' }}>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      component="div"
                      count={totalCount}
                      rowsPerPage={this.state.rowsPerPage}
                      page={this.state.page}
                      backIconButtonProps={{
                        'aria-label': 'Previous Page',
                      }}
                      nextIconButtonProps={{
                        'aria-label': 'Next Page',
                      }}
                      onPageChange={this.handleChangePage}
                      onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />
                  </div>
                </div>
              )
            }
            return (
              <LoadingSpinner />
            );
          }}
        />


      </div>
    );
  }
}

PlanHistory.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(PlanHistory);
